"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Line = void 0;

var _react = _interopRequireDefault(require("react"));

var _helpers = require("../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Line is the component responsible for rendering a line that goes through all of the data points
 * in a line chart.
 */
var Line = function Line(_ref) {
  var path = _ref.path;
  return /*#__PURE__*/_react.default.createElement("path", {
    fill: "none",
    stroke: (0, _helpers.color)("black10"),
    d: path
  });
};

exports.Line = Line;
Line.displayName = "Line";
//# sourceMappingURL=Line.js.map